<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="550"
      overlay-color="rgba(39, 50, 64)"
      overlay-opacity="0.6"
      :fullscreen="$vuetify.breakpoint.xs ? true : false"
      persistent
      :transition="false"
    >
      <v-card>
        <v-card-title
          class="header info"
          primary-title
        >
          <b>{{ $t("rankings.advancedSettings") }}</b>
        </v-card-title>

        <v-card-text>
          <v-flex>
            <v-select
              v-model.trim="risk_ratio"
              class="mt-10"
              :items="riskRatioSettings"
              :item-text="'text'"
              :item-value="'id'"
              name="risk_ratio"
              :label="$t('rankings.lotSize')"
            >
              <template v-slot:append>
                <v-tooltip
                  top
                  max-width="360"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t("rankings.lotSizeHint") }}
                </v-tooltip>
              </template>
            </v-select>
            <v-select
              v-model.trim="max_drawdown"
              :items="maxDrawdownSettings"
              :item-text="'text'"
              :item-value="'id'"
              name="max_drawdown"
              :label="$t('rankings.maxDrawdown')"
            >
              <template v-slot:append>
                <v-tooltip
                  top
                  max-width="360"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on">
                      mdi-information-outline
                    </v-icon>
                  </template>
                  {{ $t("rankings.maxDrawdownHint") }}
                </v-tooltip>
              </template>
            </v-select>
            <p class="text-justify">
              <span>
                {{ $t('rankings.advancedSettingsHint2') }}
              </span>
            </p>
          </v-flex>
        </v-card-text>

        <v-divider />

        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            :disabled="loading"
            @click="$emit('closeAdvancedSettingsDialog', false)"
          >
            {{ $t("globals.cancelButton") }}
          </v-btn>
          <v-btn
            color="primary"
            :loading="loading"
            :disabled="loading"
            @click="save()"
          >
            {{ $t("globals.saveButton") }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>

const filterValue = (obj, key, value) => obj.filter(v => v[key] == value);
const UPDATE_CONNECTION_MUTATION = require('@/graphql/mutations/UpdateConnection.gql');

export default {
  name: "AdvancedSettingsDialog",
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
    maxDrawdown: {
      type: Number,
      default: 0
    },
    riskRatio: {
      type: Number,
      default: 1
    },
    connectionId: {
      type: Number,
      default: null
    }
  },
  data() {
    return {
      risk_ratio: null,
      max_drawdown: null,
      loading: false,
      error: null,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.showDialog;
      },
      set(val) {}
    },
    riskRatioSettings() {
      let ratios = []
      for (var i = 10; i <= 200; i += 10) {
        ratios.push({'id': i / 100, 'text' : i + '%'})
      } 
     return ratios
    },
    maxDrawdownSettings() {
      let drawdown = []
      for (var i = 10; i <= 100; i += 1) {
        drawdown.push({'id': i, 'text' : i + '%'})
      } 
     return drawdown
    }
  },
  mounted() {
    this.max_drawdown = (filterValue(this.maxDrawdownSettings, 'id', this.maxDrawdown))[0].id
    this.risk_ratio = (filterValue(this.riskRatioSettings, 'id', this.riskRatio))[0].id
  },
  methods: {
    save() {
      this.loading = true;
      let params = {
        drawdown: this.max_drawdown,
        risk_ratio: this.risk_ratio,
        connection_id: this.connectionId
      };
      this.$apollo
        .mutate({
          mutation: UPDATE_CONNECTION_MUTATION,
          variables: params
        })
        .then(data => {
          this.responseHandler(data)
          this.$emit('closeAdvancedSettingsDialog', true);
        })
        .catch(error => {
          this.errorHandler(error);
          this.loading = false;
        });
    }
  },
};
</script>

<style></style>
